const colorInputs = document.querySelectorAll('input[name="Color"]');
const sizeInputs = document.querySelectorAll('input[name="Size"]');
const variantRatios = document.querySelector("variant-radios");

if (colorInputs) {
  adjustVariants();
  colorInputs.forEach((colorInput) => {
    colorInput.addEventListener("change", adjustVariants);
  });
}

function adjustVariants() {
  const selectedColor = document.querySelector('input[name="Color"]:checked');
  const variantValue = selectedColor.value;
  let selectedColorSizes = selectedColor.dataset.archiveVariants;
  selectedColorSizes = selectedColorSizes.split(",");
  const sizeOptions = document.querySelectorAll('input[name="Size"]');
  let optionChecked = false;
  sizeOptions.forEach((sizeOption) => {
    let match = false;
    const size = sizeOption.value;
    if (variantRatios.dataset.archive === "true") {
      selectedColorSizes.forEach((selectedColorSize) => {
        if (
          selectedColorSize.includes(variantValue) &&
          selectedColorSize.includes(size)
        ) {
          match = true;
        }
      });
      if (match) {
        if (sizeOption.checked) {
          optionChecked = true;
        }
        sizeOption.removeAttribute("disabled");
        sizeOption.nextElementSibling.classList.remove("hidden");
      } else {
        sizeOption.setAttribute("disabled", true);
        sizeOption.nextElementSibling.classList.add("hidden");
      }
    } else {
      selectedColorSizes.forEach((selectedColorSize) => {
        if (
          selectedColorSize.includes(variantValue) &&
          selectedColorSize.includes(size)
        ) {
          match = true;
        }
      });
      if (!match) {
        if (sizeOption.checked) {
          optionChecked = true;
        }
        sizeOption.removeAttribute("disabled");
        sizeOption.nextElementSibling.classList.remove("hidden");
      } else {
        sizeOption.setAttribute("disabled", true);
        sizeOption.nextElementSibling.classList.add("hidden");
      }
    }
  });
  if (!optionChecked) {
    sizeOptions.forEach((sizeOption) => {
      if (!sizeOption.disabled) {
        sizeOption.checked = true;
      }
    });
  }
}
